import CustomCard from "../../../../../components/CustomCard";
import {Avatar} from "@mui/material";
import IconPersonDefault from "../../../../../assets/ImagesDefaults/ic-person-v2.svg";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import {
    ArrowRightIcon,
    IconClockTable,
    IconDateTimeCalendar,
    IconDeviceFixed,
    IconMarkerTable
} from "../../../../../components/buttons/IconButtons";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    getDateFormat,
    getTimeFormat
} from "../../../../../Apis/functions";
import {userType} from "../../../../../enums/userTypeEnum";
import {getAccessMethodIcon, getAccessMethodLabel} from "../../../../../enums/accessMethodEnum";
import React from "react";
import {DEVICE_ICON_BY_TYPE} from "../../../../../hooks/deviceTypeEnum";
import AccessInfoItem from "./AccessInfoItem";
import ButtonActionsCard from "../../../../../components/buttons/ButtonActionsCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 08 de 05 de 2026
 */
const DailyAccessMonitoringCompactRow = ({row, t,setShowModal,setItemEmployee}) => {

    const deviceIcon = DEVICE_ICON_BY_TYPE[row.entryDeviceTypeId] || IconDeviceFixed;
    const accessMethodIcon = getAccessMethodIcon(row?.entryAccessMethodId || row?.accessMethodId);
    const accessInfoItems = [
        {
            icon: IconDateTimeCalendar,
            label: t('date'),
            value: getDateFormat(row.entryDate, false, DATE_TIME_FORMAT_NAME_MODEL.monthWithDayYear),
        },
        {
            icon: IconClockTable,
            label: t('time'),
            value: getTimeFormat(row.entryDate),
        },
        {
            icon: IconMarkerTable,
            label: t('zone'),
            value: row.entryZoneName,
        },
        {
            icon: accessMethodIcon,
            subIcon: deviceIcon,
            label: getAccessMethodLabel(row?.entryAccessMethodId || row?.accessMethodId, t),
            value: row.entryDeviceName,
        }
    ];

    return (
        <>
            <div className='col-sm-12 col-md-6 col-lg-5 py-1 py-lg-0'>
                <div className="d-flex align-items-center gap-12px">
                    <CustomCard classCard='card-border-8px' classContent='p-0 background-primary-25'>
                        {row.image ? (
                            <img src={`data:image/jpeg;base64,${row.image}`} alt="avatar"
                                className="w-40px h-40px object-fit-cover rounded-circle"
                            />
                        ) : (
                            <Avatar src={IconPersonDefault} className='me-12px p-1'/>
                        )}
                    </CustomCard>

                    <div className='flex-grow-0 minw-0'>
                        <CustomTooltip
                            text={row.fullName}
                            classes='fs-16px ibl-font-w-600 text-capitalize text-ellipsis-1-row'
                            showIfTruncated
                            placement='top'
                        />
                    </div>
                    <div className='vertical-separator-shades-950 h-36px d-none d-md-block'/>
                    <CustomChip
                        legend={t(userType[row?.userType || row?.userType?.id]) || EMPTY_VALUES.DEFAULT}
                        background={colors.secondary100}
                        fontColor={colors.secondary700}
                        borderColor={colors.secondary150}
                    />
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-5 py-1 py-lg-0'>
                <div className='d-flex flex-wrap justify-content-start justify-content-lg-end align-items-center'>
                    {accessInfoItems.map((item, index) => (
                        <AccessInfoItem
                            key={index}
                            icon={item.icon}
                            label={item.label}
                            value={item.value}
                        />
                    ))}
                </div>
            </div>
            <div className='col-sm-12 col-md-12 col-lg-2 py-1 py-lg-0'>
                <div className='d-flex justify-content-lg-end'>
                    <ButtonActionsCard
                        id="btn_dam_details"
                        name={'details'}
                        Icon={ArrowRightIcon}
                        onClick={() => {
                            setShowModal(true);
                            setItemEmployee(row);
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default DailyAccessMonitoringCompactRow;
